var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RoleForm',{attrs:{"role":_vm.role,"readonly":true}})}
var staticRenderFns = []

export { render, staticRenderFns }